import { defineComponent, ref, watch } from '@vue/composition-api';
const MAX_BAR_WIDTH = 200;
export default defineComponent({
    name: 'OverlayMemory',
    props: {
        statistics: { type: Object, default: null },
    },
    setup(props) {
        const usedAmount = ref(0);
        const barWidths = ref({
            used: '0px',
            total: '0px',
            limit: '0px',
        });
        const updateValues = () => {
            const { used, total, limit, } = props.statistics;
            usedAmount.value = Math.ceil(used / 1024 / 1024);
            const usedSize = MAX_BAR_WIDTH * (used / limit);
            const totalSize = (MAX_BAR_WIDTH * (total / limit)) - usedSize;
            const limitSize = MAX_BAR_WIDTH - totalSize - usedSize;
            barWidths.value = {
                used: `${usedSize}px`,
                total: `${totalSize}px`,
                limit: `${limitSize}px`,
            };
        };
        watch(() => props.statistics, updateValues);
        return {
            usedAmount,
            barWidths,
        };
    },
});
